import React, { useCallback, useState } from "react";
import { Button, Input } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { TABLE_HEADER } from "../../constants/translates";
import { LoadEntities } from "./Interfaces";

interface Props {
  store: LoadEntities;
}

const Search: React.FC<Props> = ({ store }) => {
  const [searchValue, setSearchValue] = useState<string>(
    (store.parameters.searchPhrase as string | undefined) || ""
  );

  const handOnSearch = useCallback(
    (value: string) => {
      store.load(
        {
          page: 1,
          searchPhrase: value,
        },
        true
      );
    },
    [store]
  );

  const clearSearchHandler = useCallback(() => {
    setSearchValue("");
    store.load(
      {
        page: 1,
        searchPhrase: null,
      },
      true
    );
  }, [store]);

  return (
    <Input.Search
      onChange={(event) => setSearchValue(event.target.value)}
      className="search-input"
      onSearch={handOnSearch}
      value={searchValue}
      addonAfter={
        <Button
          className="ant-btn ant-btn-icon-only ant-input-search-button search-input__reset-button"
          onClick={clearSearchHandler}
        >
          <CloseOutlined />
        </Button>
      }
      placeholder={TABLE_HEADER.searchPlaceholder}
    />
  );
};

export default Search;
